<template>
  <div>
    <v-list two-line>
      <v-list-item-group
        multiple
        v-if="users"
      >
        <template v-for="(profile, index) in users">
          <v-list-item
            :key="profile.id"
            class="pa-0 px-2 pt-0"
            inactive
            @click="handleProfileViewClick(profile.id, index)"
          >
            <v-list-item-avatar
              width="62"
              height="62"
              class="mr-3"
            >
              <ProfilePic
                :src="profile.picture"
                :width="62"
              />
            </v-list-item-avatar>

            <v-list-item-content align="top">
              <v-list-item-title class="subtitle-1 mb-0 pb-0">
                <strong>{{ profile.name }}</strong>
              </v-list-item-title>

              <v-list-item-subtitle class="role subtitle-1 ma-0 mb-1">
                {{ profile.role }}
              </v-list-item-subtitle>

              <v-list-item-subtitle class="location">
                {{ profile.location }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <ViewBtn
                class="mt-1"
                title="View profile"
                :loading="!!isFetchingProfile[index]"
              />
            </v-list-item-action>
          </v-list-item>

          <v-divider
            v-if="index + 1 < users.length"
            :key="index"
          />
        </template>
      </v-list-item-group>
    </v-list>
    <UserProfileDialog
      :show="showViewProfileDialog"
      :profile="referralProfile"
      @hide="handleViewUserDialogHide"
    />
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import ProfilePic from '@/components/core/ProfilePic.vue'
import ViewBtn from '@/components/core/ViewBtn.vue'
import { IUser } from '@/types/models/user.model'
import { waitAsync } from '@/utils/common'
import { MODAL_TRANSITION_TIME } from '@/constants'
import { userReferralsEvents } from '@/segmentAnalytics/connections'

@Component({
  components: {
    ProfilePic,
    ViewBtn
  },
  computed: {
    ...mapGetters(['isAdmin'])
  }
})
export default class ListReferrals extends Vue {
  @Prop({ required: true, default: [] }) users: IUser

  showViewProfileDialog: boolean = false
  referralProfile: IUser|null = null
  isFetchingProfile: {[key:string]: boolean} = {}

  beforeCreate () {
    if (this.$options.components) {
      // circular dependency
      this.$options.components.UserProfileDialog = require('@/components/profile/UserProfileDialog.vue').default
    }
  }

  async handleProfileViewClick (id: number, index: number) {
    userReferralsEvents.trackProfileView()
    this.isFetchingProfile[index] = true
    const userData = await this.$store.dispatch('getUser', id)
    this.isFetchingProfile[index] = false
    if (!userData) return
    this.referralProfile = userData
    this.showViewProfileDialog = true
  }

  async handleViewUserDialogHide () {
    this.showViewProfileDialog = false
    await waitAsync(MODAL_TRANSITION_TIME)
    this.referralProfile = null
  }
}
</script>
